import {Col, Row, FormGroup, Input, Label} from "reactstrap";
import React from "react";
import Nouns from "./Nouns";

const CohesityInputs = ({ device, domain, port, apiToken, handleInputChange, lgColSize }) => {
    if (Nouns.CohesityDevices.includes(device?.trim().toUpperCase())) {
        return (
            <Row>
                <Col lg={lgColSize} sm={6}>
                    <FormGroup>
                        <Label htmlFor="domain">Domain</Label>
                        <Input required type="text" name="domain" value={domain} onChange={handleInputChange}/>
                    </FormGroup>
                </Col>
                <Col lg={lgColSize} sm={6}>
                    <FormGroup>
                        <Label htmlFor="apiToken">API Token (Optional)</Label>
                        <Input required type="text" name="api_token" value={apiToken} onChange={handleInputChange}/>
                    </FormGroup>
                </Col>
            </Row>
        )
    } else {
        return null;
    }
}

export default CohesityInputs;